import React from 'react'

import createEditorStore from '@slite/editor/lib/plugins/utils/createStore'

const context = React.createContext(null)

class ProviderWrapper extends React.Component {
  eventBusStore = null

  constructor(props) {
    super(props)
    this.eventBusStore = createEditorStore()
  }

  render() {
    return (
      <context.Provider value={this.eventBusStore}>
        {this.props.children}
      </context.Provider>
    )
  }
}

export const Provider = ProviderWrapper
export const Consumer = context.Consumer
